export const SET_LOADING = 'SET_LOADING';
export const SET_LOADING_INVENTORY_COUNTS = 'SET_LOADING_INVENTORY_COUNTS';
export const SET_VEHICLES = 'SET_VEHICLES';
export const SET_INVENTORY_COUNTS = 'SET_INVENTORY_COUNTS';
export const SET_WIDGET_DATA = 'SET_WIDGET_DATA';
